export default "__VITE_ASSET__64c1d242__"